import { Grid } from '@mui/material';
import React from 'react';
import { OVERVIEW_STATES } from '../../../constants';
import { useAppControl } from '../../../providers/AppContext';
import { useLayout } from '../../../providers/LayoutContext';
import DataChildBlock from './DataChildBlock';

const DataBlock = () => {
    const { overviewState } = useAppControl();
    const { matchesLgUp } = useLayout();

    return (
        <Grid
            container
            sx={{
                p: overviewState === OVERVIEW_STATES.HIDDEN || !matchesLgUp ? 0 : 3,
                height: '100%',
                backgroundColor: '#fff',
                overflow: !matchesLgUp ? '' : 'auto',
                borderBottomLeftRadius: '8px',
                borderBottomRightRadius: '8px',
            }}
            alignItems="flex-start"
            alignContent="flex-start"
        >
            <DataChildBlock />
        </Grid>
    );
};

export default DataBlock;
